export default "__VITE_ASSET__DoP3Kaiz__"